module.exports = __webpack_public_path__ + "assets/img/goals.0f589ca4.svg";